<template>
  <div class="con-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
      <el-button type="primary" @click="addOrder">下一步</el-button>
    </div>
    <div class="con-wrap-inner">
      <el-aside width="280px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">区域列表</div>
          </el-col>
          <el-col :span="2" :offset="6"></el-col>
        </el-row>
        <div>
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="areaTreeData"
                node-key="id"
                @node-click="clickArea"
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </el-aside>

      <el-aside width="280px">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">基站列表</div>
          </el-col>
        </el-row>
        <!-- 添加回车搜索 -->
        <div class="station-search">
          <el-input
            @blur="getStationList"
            @keyup.enter.native="getStationList"
            placeholder="请输入站址名称"
            prefix-icon="el-icon-search"
            v-model="stationName"
          ></el-input>
        </div>
        <div style="margin-top: 16px">
          <el-checkbox-group
            class="station-list"
            v-model="checkStationList"
            style="position: relative"
          >
            <el-checkbox
              class="is-show"
              v-for="item in pageStationList"
              :label="item.stationId"
              :key="item.stationId"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
          <p class="load-more" @click="loadMore" v-if="moreShow">
            点击加载更多...
          </p>
        </div>
      </el-aside>

      <el-container style="flex-direction: column; width: 100%">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">运维小组列表</div>
          </el-col>
        </el-row>
        <div class="group-box">
          <div class="user-box">
            <el-button
              type="primary"
              class="show-station"
              @click="getStationLocal"
              >显示已选基站</el-button
            >
            <div v-for="item in userList" :key="item.personnelId">
              <p class="user-title">{{ item.name }}</p>
              <el-checkbox-group v-model="selectForm">
                <!-- @click.native="checkPlate(data.personnelId)" -->
                <!-- @click.native.prevent 阻止默认事件，button的默认事件【不会显示button被选中】，不用阻止冒泡，因为父级没有事件【触发没有反应】 -->
                <el-checkbox-button
                  v-for="data in item.personnelOptions"
                  :label="data.personnelId"
                  :key="data.personnelId"
                  >{{ data.name }}
                  <p>{{ data.plate }}</p></el-checkbox-button
                >
              </el-checkbox-group>
            </div>
          </div>
          <div id="map-box"></div>
        </div>
      </el-container>
    </div>
    <!--新增工单-->
    <el-dialog
      title="工单内容"
      :visible.sync="addOrderVisible"
      class="mini-dialog"
      width="625px"
    >
      <el-form
        :rules="rules"
        ref="orderForm"
        :model="orderForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="type" label="工单类型">
          <el-select
            v-model="orderForm.type"
            @change="changeType"
            clearable
            placeholder="请选择工单类型"
            style="width: 465px"
          >
            <el-option
              v-for="item in orderType"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-required" label="停电时间" v-if="flag">
          <date-picker
            style="width: 465px"
            :startTime="orderFormStartTime"
            :endTime="orderFormEndTime"
            :startText="'计划停电开始时间'"
            :endText="'计划停电结束时间'"
            @changeStart="changeStart"
            @changeEnd="changeEnd"
          >
          </date-picker>
        </el-form-item>
        <el-form-item prop="errorId" label="故障内容">
          <el-select
            v-model="orderForm.errorId"
            clearable
            placeholder="请选择故障内容"
            style="width: 465px"
          >
            <el-option
              v-for="item in faultList"
              :key="item.id"
              :label="item.content"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOrderVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      selectPlate: [],
      areaTreeData: [],
      stationName: "",
      stationList: [],
      pageStationList: [],
      checkStationList: [],
      areaId: "",
      groupId: "",
      selectForm: [],
      userList: [],
      addOrderVisible: false,
      orderFormStartTime: "",
      orderFormEndTime: "",
      orderForm: {
        errorId: "",
        type: "",
      },
      rules: {
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择工单类型",
          },
        ],
        errorId: [
          {
            required: true,
            trigger: "change",
            message: "请选择故障内容",
          },
        ],
      },
      orderType: [
        {
          code: 1,
          value: "计划发电",
        },
        {
          code: 2,
          value: "应急发电",
        },
      ],
      faultList: [],
      flag: false,
      moreShow: false,
      nowPage: 1,
      //添加地图需求
      map: null,
      scale: null,
      center: [],
      vehicleLocal: [],
      stationLocal: [],
      infoWindow: null,
      vehicleMarker: [],
      stationMarker: [],
      origin: "",
    };
  },
  created() {
    this.getAreaList();
    this.getFaultList();
    this.getVehicleLocation();
  },
  mounted() {
    this.init();
  },
  watch: {
    selectForm(newValue, old) {
      let count = newValue.length - old.length;
      let childrenList = [];
      let childrenOne = [];
      let childrenObj = [];
      this.userList.forEach((item) => {
        childrenList.push(...item.personnelOptions);
      });
      newValue.forEach((i) => {
        childrenOne = childrenList.filter((items) => {
          return items.personnelId === i && items.status == 2;
        });
        childrenObj = childrenOne[0];
      });
      if (count >= 0 && childrenObj && childrenObj.status == 2) {
        this.$confirm(
          "该车辆保养里程已超限，无法开启发电功能，是否继续派单？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "继续派单!",
            });
          })
          .catch(() => {
            // 取消选中，由于选中超里程的车辆会弹出提示框，所以在选中数组中一定是最后一个
            let i = this.selectForm[this.selectForm.length - 1];
            // 过滤出来选中数组中只包含未超出保养里程的值
            this.selectForm = this.selectForm.filter((item) => {
              return item != i;
            });
            this.$message({
              type: "info",
              message: "已取消继续派单",
            });
          });
      }
      this.vehicleLocal.forEach((item) => {
        if (this.selectForm.includes(item.id)) {
          // 选中的是哪个车辆
          item.icon = true;
          this.center = item.lnglat;
          // this.map.setCenter(item.lnglat);
        } else {
          item.icon = false;
        }
      });
      this.addVehicleMarker();
    },
    // 默认点击Tree第一个节点
    areaTreeData(val) {
      if (val) {
        this.$nextTick(() => {
          document.querySelector(".el-tree-node__content").click();
        });
      }
    },
  },
  methods: {
    // checkbox-group 绑定值变化时触发弹框提示保养里程超限
    // overrun(newValue,oldValue) {
    //   console.log(newValue,oldValue);
    //   let childrenList = [];
    //   let childrenOne = [];
    //   let childrenObj = [];
    //   this.userList.forEach((item) => {
    //     childrenList.push(...item.personnelOptions);
    //   });
    //   newValue.forEach((i) => {
    //     childrenOne = childrenList.filter((items) => {
    //       return items.personnelId === i && items.status == 2;
    //     });
    //     childrenObj = childrenOne[0];
    //   });
    //   console.log(childrenObj);
    //   if (childrenObj && childrenObj.status == 2) {
    //     this.$confirm(
    //       "该车辆保养里程已超限，无法开启发电功能，是否继续派单？",
    //       "提示",
    //       {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //       }
    //     )
    //       .then(() => {
    //         this.$message({
    //           type: "success",
    //           message: "继续派单!",
    //         });
    //       })
    //       .catch(() => {
    //         // 取消选中，由于选中超里程的车辆会弹出提示框，所以在选中数组中一定是最后一个
    //         let i = this.selectForm[this.selectForm.length - 1];
    //         // 过滤出来选中数组中只包含未超出保养里程的值
    //         this.selectForm = this.selectForm.filter((item) => {
    //           console.log(item);
    //           return item != i;
    //         });
    //         this.$message({
    //           type: "info",
    //           message: "已取消继续派单",
    //         });
    //       });
    //   }
    // },
    changeStart(val) {
      this.orderFormStartTime = val;
    },
    changeEnd(val) {
      this.orderFormEndTime = val;
    },
    goback() {
      this.$router.push("/Dispatch");
    },
    init() {
      this.map = new AMap.Map("map-box", {
        center: [116.397428, 39.90923],
        resizeEnable: true,
        zoom: 12,
        mapStyle: "amap://styles/fresh",
      });
      this.geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });

      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });

      //this.infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(0, -30) })
      this.infoWindow = new AMap.InfoWindow();
    },
    async getAreaList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        _this.areaTreeData = res.data;
        _this.areaId = res.data[0].id;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clickArea(areaDatas) {
      this.areaId = areaDatas.id;
      this.userList = [];
      this.getStationList();
      this.getUserList();
    },
    async getStationList() {
      let _this = this;
      let areaId = this.areaId;
      let parm = {
        areaId: areaId,
        name: _this.stationName,
      };
      let { data: res } = await _this.$axios.get("/api/base/station/options", {
        params: parm,
      });
      if (res.code == 1) {
        if (res.data.length >= 50) {
          this.moreShow = true;
          _this.stationList = res.data;
          _this.pageStationList = _this.stationList.slice(0, 50);
        } else {
          this.moreShow = false;
          _this.pageStationList = res.data;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserList() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/maintain/dept/options/group?areaId=" + _this.areaId
      );
      if (res.code == 1) {
        _this.userList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getFaultList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/error/content/options");
      if (res.code == 1) {
        _this.faultList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    addOrder() {
      if (this.checkStationList == "") {
        this.$message.warning("请先选择基站");
        return;
      }
      if (this.selectForm == "") {
        this.$message.warning("请先选择运维人员");
        return;
      }
      this.addOrderVisible = true;
      this.$resetForm(this, "orderForm");
      this.orderForm = {};
      this.flag = false;
    },
    async saveOrUpdate() {
      let _this = this;
      let startTime = "";
      let endTime = "";
      _this.$refs.orderForm.validate(async (valid) => {
        if (valid) {
          if (this.flag) {
            startTime = _this.orderFormStartTime;
            endTime = _this.orderFormEndTime;
            if (!startTime || !endTime) {
              this.$message.warning("请选择计划发电时间");
              return;
            }
          }
          let orderManageAdds = [];
          let parm = {};
          for (var index in _this.checkStationList) {
            let obj = {
              endTime: endTime,
              errorId: _this.orderForm.errorId,
              startTime: startTime,
              stationId: _this.checkStationList[index],
              type: _this.orderForm.type,
            };
            orderManageAdds.push(obj);
          }
          parm = {
            orderManageAdds: orderManageAdds,
            personnelIds: _this.selectForm,
          };

          let { data: res } = await _this.$axios.post(
            "/api/v2/order/manage",
            parm
          );
          if (res.code == 1) {
            _this.addOrderVisible = false;
            _this.checkStationList = [];
            _this.selectForm = [];
            _this.orderFormStartTime = "";
            _this.orderFormEndTime = "";
            _this.$resetForm(_this, "orderForm");
            _this.map.remove(_this.stationMarker);
            _this.infoWindow.close();
            _this.$message.success("操作成功");
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    changeType() {
      this.flag = this.orderForm.type == 1 ? true : false;
    },
    loadMore() {
      this.pageStationList = this.pageStationList.concat(
        this.stationList.slice(this.nowPage * 50, (this.nowPage + 1) * 50)
      );
      this.nowPage++;
      if (this.stationList.length >= this.nowPage * 50) {
        this.moreShow = true;
      } else {
        this.moreShow = false;
      }
    },
    //获取车辆定位信息
    async getVehicleLocation() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/order/manage/vehicle/gps"
      );
      if (res.code == 1) {
        _this.vehicleLocal = res.data;
        _this.addVehicleMarker();
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //获取基站定位信息
    async getStationLocal() {
      if (this.stationMarker.length) {
        this.map.remove(this.stationMarker);
      }
      let _this = this;
      if (_this.checkStationList == "") {
        _this.$message.warning("请先选择基站");
        return;
      }
      let { data: res } = await _this.$axios.post(
        "/api/base/station/gps",
        _this.checkStationList
      );
      if (res.code == 1) {
        _this.stationLocal = res.data;
        _this.addStationMarker();
        _this.$message.success("操作成功");
      } else {
        _this.$message.warning(res.msg);
      }
    },
    //添加车辆标记
    addVehicleMarker() {
      let _this = this;
      let data = this.vehicleLocal;
      if (_this.vehicleMarker.length) {
        _this.map.remove(_this.vehicleMarker);
      }
      let marker = "";
      let myIcon = "";
      let vehicleMarker = [];
      for (let i = 0; i < data.length; i++) {
        // 找出选中的车辆改变图标
        if (data[i].icon) {
          myIcon = new AMap.Icon({
            image: require("@/assets/images/car-online-active.png"),
            imageSize: new AMap.Size(36, 36),
            size: [36, 36],
            offset: new AMap.Pixel(-14, 0),
            // // 图标取图偏移量
            // imageOffset: new AMap.Pixel(0, -4),
          });
        } else {
          myIcon = new AMap.Icon({
            image: require("@/assets/images/car-online.png"),
            imageSize: new AMap.Size(36, 36),
            size: [36, 36],
            // 图标取图偏移量
            // imageOffset: new AMap.Pixel(7, 3),
          });
        }
        marker = new AMap.Marker({
          position: data[i].lnglat,
          icon: myIcon,
          size: new AMap.Size(20, 30),
          map: _this.map,
          offset: new AMap.Pixel(-14, 0),
        });
        // 给选中的车辆添加label标签，给未选中的车辆添加隐藏的label标签
        if (data[i].icon) {
          // 设置label标签
          // 样式className为：amap-marker-label
          marker.setLabel({
            direction: "center",
            offset: new AMap.Pixel(-12, -52), //设置文本标注偏移量
            content: `<div class='info'>${data[i].groupName +
              "：<br/>" +
              data[i].personnelName}</div>`, //设置文本标注内容
          });
          // 打开label时将车辆窗体关闭
          if (_this.infoWindow.getIsOpen()) {
            _this.infoWindow.close();
          }
          console.log(_this.infoWindow, _this.infoWindow.getIsOpen());
        } else {
          marker.setLabel({
            direction: "center",
            offset: new AMap.Pixel(-12, -52), //设置文本标注偏移量
            content: `<div class='hide_info'>${data[i].groupName +
              "：<br/>" +
              data[i].personnelName}</div>`, //设置文本标注内容
          });
        }
        if (data[i].icon) {
          marker.setTop(true);
        } else {
          marker.setTop(false);
        }
        vehicleMarker.push(marker);
        marker.content = data[i];
        AMap.event.addListener(marker, "click", function(e) {
          if (!_this.selectForm.includes(e.target.content.id)) {
            // 选中车辆再次点击图标时不创建车辆窗体
            _this.infoWindow.setContent(
              e.target.content.groupName +
                "：<br/>" +
                e.target.content.personnelName
            );
            _this.infoWindow.open(_this.map, e.target.content.lnglat);
            _this.origin = "";
            marker.setTop(true);
          }
          // console.log(e.target.content.id, _this.userList);
          // // 点击车辆发现选中运维列表中已经有该点击车俩，需要取消选中
          // let index = _this.selectForm.indexOf(e.target.content.id);
          // if (index > -1) {
          //   // 找到该数组中的要删除元素位置
          //   _this.selectForm.splice(index, 1);
          //   e.target.content.icon = false;
          //   _this.origin = e.target.content.lnglat;
          //   marker.setTop(false);
          // } else {
          // e.target.setLabel({
          //   direction: "center",
          //   offset: new AMap.Pixel(-12, -44), //设置文本标注偏移量
          //   content: `<div class='info'>${e.target.content.groupName +
          //     "：<br/>" +
          //     e.target.content.personnelName}</div>`, //设置文本标注内容
          // });
          // _this.selectForm.push(e.target.content.id);
          // e.target.content.icon = true;
        });
      }
      _this.vehicleMarker = vehicleMarker;
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.add(_this.vehicleMarker);
        _this.map.setZoom(12);
        // //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
    //添加基站标记
    addStationMarker() {
      let _this = this;
      let data = this.stationLocal;
      if (_this.stationMarker.length) {
        _this.map.remove(_this.stationMarker);
      }
      _this.stationMarker = [];
      for (var i = 0; i < data.length; i++) {
        let marker = "";
        marker = new AMap.Marker({
          position: data[i].lnglat,
          icon: require("@/assets/images/base-station.png"),
          size: new AMap.Size(20, 30),
          map: _this.map,
          offset: new AMap.Pixel(-12, 0),
        });
        _this.stationMarker.push(marker);
        marker.content = data[i].groupName;
        AMap.event.addListener(marker, "click", function() {
          _this.infoWindow.setContent(marker.content);
          _this.infoWindow.open(_this.map, marker.getPosition());
        });
        //默认打开一个基站信息框
        // _this.stationMarker.emit("click", { target: marker })
      }
      _this.$nextTick(() => {
        // 更改地图中心点
        _this.map.add(_this.stationMarker);
        _this.map.setZoom(10);
        //依据第一个坐标位置设置中心点
        //_this.map.setCenter(data[0].lnglat)
        //适应所有坐标点合适视野居中
        _this.map.setFitView();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.con-wrap-inner {
  width: 100%;
  height: calc(100% - 68px);
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
}
.con-wrap-inner .el-container {
  background-color: #fff;
}
.station-list .is-show {
  height: 28px;
  line-height: 28px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 0;
  font-size: 14px;
  padding: 0 14px;
  cursor: pointer;
}
.station-list .is-show:hover {
  background: #f5f7fa;
}
.station-search {
  padding: 0 10px;
  & /deep/ {
    .el-input__inner {
      height: 32px;
    }
    .el-input__icon {
      line-height: 34px;
    }
  }
}
.user-box {
  display: inline-block;
  width: 262px;
  height: 100%;
  overflow: auto;
}
.user-title {
  height: 26px;
  line-height: 26px;
  margin-left: 20px;
  padding-left: 10px;
  border-left: 3px solid #0093ff;
  font-weight: bold;
}
.user-box /deep/ .el-checkbox-group {
  width: 100%;
  height: 100%;
  margin-bottom: 20px;
  padding: 0 20px;
  box-sizing: border-box;
}
.user-box /deep/ .el-checkbox-button__original {
  left: 0;
}
.user-box /deep/ .el-checkbox-button__inner {
  width: 100%;
  height: 100%;
  float: left;
  line-height: 26px;
  padding: 0;
  box-sizing: initial;
  border: 0;
}
.user-box /deep/ .el-checkbox-button:first-child .el-checkbox-button__inner {
  border: 0;
}
.user-box /deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: #0094ff;
  color: #fff;
  border-color: #0094ff;
}
.user-box /deep/ .el-checkbox-button {
  width: 88px;
  height: 44px;
  overflow: hidden;
  line-height: 30px;
  margin: 6px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  p {
    line-height: 14px;
    font-size: 12px;
    text-align: center;
  }
}
.con-wrap /deep/ .el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 420px;
}
.load-more {
  height: 28px;
  line-height: 28px;
  padding-left: 40px;
  text-align: left;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}
::v-deep .amap-icon {
  left: -10px;
  top: 2px;
}
//地图
#map-box {
  display: inline-block;
  width: calc(100% - 262px);
  height: 100%;
}
.group-box {
  width: 100%;
  height: calc(100% - 42px);
  flex-direction: row;
  display: flex;
  padding: 0 10px 10px 0;
  box-sizing: border-box;
  overflow: hidden;
}
.show-station {
  width: 100px;
  margin: 0 0 10px 20px;
}
#map-box /deep/ .amap-info-content {
  padding: 10px 25px;
  border: 1px solid #ccc;
  border-radius: 6px;
  line-height: 20px;
  font-size: 14px;
  color: #333;
}

::v-deep .amap-marker-label {
  border: 0;
  padding: 0;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  line-height: 20px;
  border: 1px solid #ccc;
  .info {
    /*正常标签样式*/
    position: relative;
    top: 0;
    right: 0;
    min-width: 0;
    padding: 10px 25px;
  }
  .info::before {
    position: absolute;
    left: 50%;
    top: 100%;
    margin-left: -8px;
    margin-top: 1px;
    content: "";
    border-top: 8px solid #fff;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: -1;
  }
  .info::after {
    position: absolute;
    content: "";
    left: 50%;
    top: 114%;
    margin-left: -8px;
    margin-top: -7px;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid rgba(0, 0, 0, 0.3);
    filter: blur(2px);
    z-index: -2;
  }

  .hide_info {
    /*隐藏标签样式*/
    display: none !important;
  }
}
</style>
